var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuotesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.814 18.6426H6.46067C3.59317 18.6426 1.6665 16.6301 1.6665 13.6351V6.70672C1.6665 3.71172 3.59317 1.69922 6.46067 1.69922H9.5765C9.9215 1.69922 10.2015 1.97922 10.2015 2.32422C10.2015 2.66922 9.9215 2.94922 9.5765 2.94922H6.46067C4.30734 2.94922 2.9165 4.42422 2.9165 6.70672V13.6351C2.9165 15.9176 4.30734 17.3926 6.46067 17.3926H13.814C15.9673 17.3926 17.359 15.9176 17.359 13.6351V10.2784C17.359 9.93339 17.639 9.65339 17.984 9.65339C18.329 9.65339 18.609 9.93339 18.609 10.2784V13.6351C18.609 16.6301 16.6815 18.6426 13.814 18.6426Z",
    fill: "url(#paint0_linear_1798_40727)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.38956 12.858H9.87039C10.1871 12.858 10.4837 12.7355 10.7079 12.5113L16.9654 6.2538C17.2221 5.99714 17.3637 5.65547 17.3637 5.29214C17.3637 4.92797 17.2221 4.58547 16.9654 4.3288L15.9512 3.31464C15.4204 2.78547 14.5571 2.78547 14.0254 3.31464L7.79789 9.54214C7.58206 9.75797 7.45956 10.0446 7.45206 10.3488L7.38956 12.858ZM9.87039 14.108H6.74873C6.58039 14.108 6.41873 14.0396 6.30123 13.9188C6.18373 13.7988 6.11956 13.6363 6.12373 13.4671L6.20206 10.318C6.21789 9.6913 6.47039 9.10214 6.91373 8.65797H6.91456L13.1421 2.43047C14.1604 1.4138 15.8162 1.4138 16.8346 2.43047L17.8487 3.44464C18.3429 3.93797 18.6146 4.5938 18.6137 5.29214C18.6137 5.99047 18.3421 6.64547 17.8487 7.13797L11.5912 13.3955C11.1321 13.8546 10.5204 14.108 9.87039 14.108Z",
    fill: "url(#paint1_linear_1798_40727)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4425 8.26656C16.2825 8.26656 16.1225 8.20573 16.0008 8.08323L12.1958 4.27823C11.9517 4.03406 11.9517 3.63823 12.1958 3.39406C12.44 3.1499 12.835 3.1499 13.0792 3.39406L16.8842 7.1999C17.1283 7.44406 17.1283 7.83906 16.8842 8.08323C16.7625 8.20573 16.6025 8.26656 16.4425 8.26656Z",
    fill: "url(#paint2_linear_1798_40727)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1798_40727",
    x1: 10.1378,
    y1: 1.69922,
    x2: 10.1378,
    y2: 18.6426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA3CE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66217D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1798_40727",
    x1: 12.3686,
    y1: 1.66797,
    x2: 12.3686,
    y2: 14.108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA3CE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66217D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1798_40727",
    x1: 14.54,
    y1: 3.21094,
    x2: 14.54,
    y2: 8.26656,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA3CE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66217D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuotesIcon);
export default __webpack_public_path__ + "static/media/quotes-icon.bf2228151a80c816c8365606f5297568.svg";
export { ForwardRef as ReactComponent };